module.exports = __webpack_public_path__ + "img/five_zhCn.b5b8c1b2.png";